<template>
  <div>
    <form @submit.prevent="save">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Suspend Connection</p>
        </header>
        <section class="modal-card-body">
          <div class="has-text-centered py-xl">
            <p>Are you sure you are ready to activate this connection?</p>
            <p>Suspended suppliers cannot receive orders or update inventory.</p>
          </div>
        </section>
        <footer class="modal-card-foot space-between">
          <b-button @click="$parent.close()">Close</b-button>
          <b-button
            type="is-danger"
            native-type="submit"
            :loading="saving"
            :disabled="saving">
            Suspend Connection
          </b-button>
        </footer>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['context']),
    endpoint () {
      return this.context.route + '/connections/' + this.connection.id + '/'
    },
    body () {
      return {
        status: 'suspended'
      }
    }
  },
  data () {
    return {
      saving: false
    }
  },
  methods: {
    save () {
      this.saving = true
      this.$http.patch(this.endpoint, this.body).then(response => {
        this.$emit('suspended:connection')
        this.$buefy.toast.open({ type: 'is-info', message: 'Connection suspended!' })
        this.$parent.close()
      }).finally(() => {
        this.saving = false
      })
    }
  },
  props: {
    connection: {
      type: Object,
      required: true
    }
  }
}
</script>
